import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { posService } from '@/services/pos.service';
import type { FulfillmentMode, PosVariantSearchResult } from '../types';

const EMPTY: PosVariantSearchResult = { serials: [], variants: [] };

export function useQrVariantSearch(qrCode: string, fulfillmentMode: FulfillmentMode) {
  const [debounced, setDebounced] = useState('');

  useEffect(() => {
    const trimmed = qrCode.trim();
    if (!trimmed) {
      setDebounced('');
      return;
    }
    const t = setTimeout(() => setDebounced(trimmed), 500);
    return () => clearTimeout(t);
  }, [qrCode]);

  const enabled = debounced.length > 0;

  const query = useQuery<PosVariantSearchResult>({
    queryKey: ['pos-variant-search', debounced, fulfillmentMode],
    queryFn: () => posService.searchVariant(debounced, fulfillmentMode),
    enabled,
    staleTime: 30_000,
    gcTime: 60_000,
    retry: false,
  });

  return {
    results: query.data ?? EMPTY,
    isSearching: enabled && query.isFetching,
    hasResults:
      (query.data?.serials.length ?? 0) > 0 || (query.data?.variants.length ?? 0) > 0,
  };
}
